// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useSellOperationData } from '@shared/portfolio-operations/providers';
import {
  calculateSharesFromPercentage,
  calculateAmountFromPercentage,
} from '@shared/portfolio-operations/utils/transfer-calculations';

const DEFAULT_PARTIAL_PERCENTAGE = 50;

export const useSellOptions = () => {
  const { form, currency, totalShares, totalAmount, onSaleTypeChange, onBlur } =
    useSellOperationData();

  const saleType = form.watch('type');

  const isFull = saleType === 'full';

  const defaultPartialShares = calculateSharesFromPercentage(
    DEFAULT_PARTIAL_PERCENTAGE,
    totalShares,
  );
  const defaultPartialAmount = calculateAmountFromPercentage(
    DEFAULT_PARTIAL_PERCENTAGE,
    totalAmount,
  );

  return {
    saleType,
    isFull,
    currency,
    totalShares,
    totalAmount,
    defaultPartialPercentage: DEFAULT_PARTIAL_PERCENTAGE,
    defaultPartialShares,
    defaultPartialAmount,
    onSaleTypeChange,
    onBlur,
  };
};
